import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import api from "../services/api";

const MissingTaxInfoPage = () => {
    const { id: businessId } = useParams();
    const [missingStates, setMissingStates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [formData, setFormData] = useState({}); // Holds the input values for each state

    useEffect(() => {
        const fetchMissingTaxInfo = async () => {
            try {
                const response = await api.get(`/missing-tax-info/${businessId}`);
                setMissingStates(response.data.missingStates || []);
                const initialFormData = {};
                response.data.missingStates.forEach((state) => {
                    initialFormData[state.state] = {
                        withholdingAccountNumber: "",
                        uiaAccountNumber: "",
                        unemploymentTaxRate: "",
                        diHandling: "",
                        employerRate: "",
                        chargesEmployee: "",
                        employeeShare: "",
                        employerShare: "",
                    };
                });
                setFormData(initialFormData);
            } catch (err) {
                console.error("Error fetching missing tax information:", err);
                setError("Failed to fetch missing tax information.");
            } finally {
                setLoading(false);
            }
        };

        fetchMissingTaxInfo();
    }, [businessId]);

    const handleInputChange = (state, field, value) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [state]: {
                ...prevFormData[state],
                [field]: value,
            },
        }));
    };

    const handleSubmit = async () => {
        try {
            const formattedData = Object.entries(formData).map(([state, data]) => ({
                state,
                ...data,
            }));
            await api.post(`/save-missing-tax-info/${businessId}`, { states: formattedData });
            alert("Missing tax information submitted successfully!");
        } catch (err) {
            console.error("Error submitting missing tax information:", err);
            alert("Failed to submit missing tax information.");
        }
    };

    if (loading) return <p>Loading missing tax information...</p>;
    if (error) return <p>{error}</p>;
    if (missingStates.length === 0) return <p>All tax information is complete!</p>;

    return (
        <div style={{ padding: "20px" }}>
            <h2>Missing Tax Information</h2>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", justifyContent: "center" }}>
                {missingStates.map((state) => (
                    <div
                        key={state.state}
                        style={{
                            width: "300px",
                            backgroundColor: "white",
                            padding: "15px",
                            border: "1px solid #ddd",
                            borderRadius: "5px",
                        }}
                    >
                        <h4 style={{ marginBottom: "10px" }}>{state.state}</h4>
                        {state.withholdingAccountNumber && (
                            <label>
                                Withholding Account Number:
                                <input
                                    type="text"
                                    value={formData[state.state]?.withholdingAccountNumber || ""}
                                    onChange={(e) =>
                                        handleInputChange(state.state, "withholdingAccountNumber", e.target.value)
                                    }
                                />
                            </label>
                        )}
                        {state.uiaAccountNumber && (
                            <label>
                                UIA Account Number:
                                <input
                                    type="text"
                                    value={formData[state.state]?.uiaAccountNumber || ""}
                                    onChange={(e) =>
                                        handleInputChange(state.state, "uiaAccountNumber", e.target.value)
                                    }
                                />
                            </label>
                        )}
                        {state.unemploymentTaxRate && (
                            <label>
                                Unemployment Tax Rate:
                                <input
                                    type="number"
                                    step="0.01"
                                    value={formData[state.state]?.unemploymentTaxRate || ""}
                                    onChange={(e) =>
                                        handleInputChange(state.state, "unemploymentTaxRate", e.target.value)
                                    }
                                />
                            </label>
                        )}
                        {state.diHandling && (
                            <label>
                                DI Handling:
                                <select
                                    value={formData[state.state]?.diHandling || ""}
                                    onChange={(e) => handleInputChange(state.state, "diHandling", e.target.value)}
                                >
                                    <option value="">Select</option>
                                    <option value="noWithdraw">No Withdraw</option>
                                    <option value="withdraw">Withdraw</option>
                                </select>
                            </label>
                        )}
                        {state.employerRate && (
                            <label>
                                Employer Rate:
                                <input
                                    type="number"
                                    step="0.01"
                                    value={formData[state.state]?.employerRate || ""}
                                    onChange={(e) => handleInputChange(state.state, "employerRate", e.target.value)}
                                />
                            </label>
                        )}
                        {state.chargesEmployee && (
                            <label>
                                Employee Charges (NY Rule):
                                <select
                                    value={formData[state.state]?.chargesEmployee || ""}
                                    onChange={(e) => handleInputChange(state.state, "chargesEmployee", e.target.value)}
                                >
                                    <option value="">Select</option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </label>
                        )}
                        {state.employeeShare && (
                            <label>
                                Employee Share:
                                <input
                                    type="number"
                                    step="0.01"
                                    value={formData[state.state]?.employeeShare || ""}
                                    onChange={(e) => handleInputChange(state.state, "employeeShare", e.target.value)}
                                />
                            </label>
                        )}
                        {state.employerShare && (
                            <label>
                                Employer Share:
                                <input
                                    type="number"
                                    step="0.01"
                                    value={formData[state.state]?.employerShare || ""}
                                    onChange={(e) => handleInputChange(state.state, "employerShare", e.target.value)}
                                />
                            </label>
                        )}
                    </div>
                ))}
            </div>
            <div style={{ textAlign: "center", marginTop: "20px" }}>
                <button
                    onClick={handleSubmit}
                    style={{
                        padding: "10px 20px",
                        backgroundColor: "teal",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                    }}
                >
                    Submit Missing Tax Information
                </button>
            </div>
        </div>
    );
};

export default MissingTaxInfoPage;



// import React, { useState, useEffect } from "react";
// import { useParams } from "react-router-dom";
// import api from "../services/api";

// const MissingTaxInfoPage = () => {
//     const { id: businessId } = useParams();
//     const [missingStates, setMissingStates] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         const fetchMissingTaxInfo = async () => {
//             try {
//                 const response = await api.get(`/missing-tax-info/${businessId}`);
//                 setMissingStates(response.data.missingStates || []);
//             } catch (err) {
//                 console.error("Error fetching missing tax information:", err);
//                 setError("Failed to fetch missing tax information.");
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchMissingTaxInfo();
//     }, [businessId]);

//     if (loading) return <p>Loading missing tax information...</p>;
//     if (error) return <p>{error}</p>;
//     if (missingStates.length === 0) return <p>All tax information is complete!</p>;

//     return (
//         <div style={{ padding: "20px" }}>
//             <h2>Missing Tax Information</h2>
//             <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", justifyContent: "center" }}>
//                 {missingStates.map((state) => (
//                     <div
//                         key={state.state}
//                         style={{
//                             width: "300px",
//                             backgroundColor: "white",
//                             padding: "15px",
//                             border: "1px solid #ddd",
//                             borderRadius: "5px",
//                         }}
//                     >
//                         <h4 style={{ marginBottom: "10px" }}>{state.state}</h4>
//                         {state.withholdingAccountNumber && <p>Requires Withholding Account Number</p>}
//                         {state.uiaAccountNumber && <p>Requires UIA Account Number</p>}
//                         {state.unemploymentTaxRate && <p>Requires Unemployment Tax Rate</p>}
//                         {state.diHandling && <p>Requires DI Handling</p>}
//                         {state.employerRate && <p>Requires Employer Rate</p>}
//                         {state.chargesEmployee && <p>Requires Employee Charges (NY Rule)</p>}
//                         {state.employeeShare && <p>Requires Employee Share</p>}
//                         {state.employerShare && <p>Requires Employer Share</p>}
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default MissingTaxInfoPage;




// import React, { useState, useEffect } from "react";
// import { useParams, Link } from "react-router-dom";
// import api from "../services/api";

// const MissingTaxInfoPage = () => {
//     const { id: businessId } = useParams();
//     const [missingStates, setMissingStates] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     useEffect(() => {
//         const fetchMissingStates = async () => {
//             try {
//                 const response = await api.get(`/missing-tax-info/${businessId}`);
//                 setMissingStates(response.data.missingStates || []);
//             } catch (err) {
//                 console.error("Error fetching missing states:", err);
//                 setError("Failed to fetch missing tax information.");
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchMissingStates();
//     }, [businessId]);

//     if (loading) return <p>Loading missing tax information...</p>;
//     if (error) return <p>{error}</p>;

//     return (
//         <div style={{ padding: "20px" }}>
//             <h2>Missing Tax Information</h2>
//             {missingStates.length > 0 ? (
//                 <div>
//                     <p>The following states are missing tax information:</p>
//                     <ul>
//                         {missingStates.map((state) => (
//                             <li key={state}>
//                                 {state} -{" "}
//                                 <Link to={`/add-tax-info/${businessId}/${state}`}>
//                                     Add Tax Information
//                                 </Link>
//                             </li>
//                         ))}
//                     </ul>
//                 </div>
//             ) : (
//                 <p>All tax information is complete.</p>
//             )}
//         </div>
//     );
// };

// export default MissingTaxInfoPage;
